module.exports = __webpack_public_path__ + "static/media/close.38d4849e.svg";